import { List, Tag } from 'antd';
import typeLabel from '@/constants/ActivityTypeLabelsStudents';
import ActivityTypeIcon from '@/shared/ActivityTypeIcon/ActivityTypeIcon';
import { StyledActivityListItem } from './ActivityListItem.styled';
import { useState } from 'react';
import TaskActivityPreview from '@/shared/TaskActivityPreview/TaskActivityPreview';
import ProgressFeedback from '../../../shared/ProgressFeedback/ProgressFeedback';
import Colors from '@/constants/Colors';
import { pxToVw } from '@/modules/styled/cssUnits';
import { getLevelLabel } from '@/constants/ActivityLevelLabels';

export default function ActivityListItem({
  taskId,
  taskActivity,
  defaultLevel,
  isPreview,
  dueDate,
  timeOffset,
}) {
  const { activity, activityConf, activityProgress, progresses } = taskActivity;

  const miniactivityConf = getMiniactivityConf(activityConf, defaultLevel);

  return (
    <StyledActivityListItem>
      <TeacherActivityLink
        taskId={taskId}
        taskActivity={taskActivity}
        miniactivityConf={miniactivityConf}
        isPreview={isPreview}
      >
        <ActivityItem
          activity={activity}
          activityConf={activityConf}
          activityProgress={activityProgress}
          progresses={progresses}
          isPreview={isPreview}
          dueDate={dueDate}
          timeOffset={timeOffset}
        />
      </TeacherActivityLink>
    </StyledActivityListItem>
  );
}

function ActivityItem({
  activity,
  activityConf,
  activityProgress,
  progresses,
  isPreview,
  dueDate,
  timeOffset,
}) {
  return (
    <List.Item
      className="activity-list-item"
      extra={
        <ProgressFeedback
          repetitions={activityConf.options?.repetitions}
          activityProgress={activityProgress}
          showCorrect={activityConf.correctness}
          progressDetail={progresses}
          isPreview={isPreview}
          dueDate={dueDate}
          timeOffset={timeOffset}
          size="small"
        />
      }
    >
      <List.Item.Meta
        avatar={
          <ActivityTypeIcon
            type={activity.type}
            color="white"
            withCircle
            circleColor={Colors.activityTypeColors[activity.type]}
            size={pxToVw(10)}
            width={pxToVw(30)}
            height={pxToVw(30)}
          />
        }
        title={
          <div className="activity-title">
            {typeLabel(
              activity.type,
              activity.data.subType,
              activityConf.miniactivityType
            )}
            {activityConf.options.level ? (
              <Tag>{getLevelLabel(activityConf.options.level)}</Tag>
            ) : null}
          </div>
        }
      />
    </List.Item>
  );
}

function TeacherActivityLink({
  taskId,
  taskActivity,
  miniactivityConf,
  children,
  isPreview,
}) {
  const { activityId, id: taskActivityId } = taskActivity;
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      {isPreview ? (
        <a className="activity-link" onClick={() => setShowModal(!showModal)}>
          {children}
        </a>
      ) : (
        children
      )}
      {showModal && (
        <TaskActivityPreview
          taskId={taskId}
          activityId={activityId}
          taskActivityId={taskActivityId}
          miniactivityConf={miniactivityConf}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
}

function getMiniactivityConf(activityConf, defaultLevel) {
  return {
    miniactivityType: activityConf.miniactivityType,
    level:
      activityConf.options?.level == 'student'
        ? defaultLevel || 'easy'
        : activityConf.options?.level,
    themes: activityConf.themes,
  };
}
